import {createRoot} from "react-dom/client";
import {library} from "@fortawesome/fontawesome-svg-core";
import {fas} from "@fortawesome/free-solid-svg-icons";
import App from "./components/main/App";

library.add(fas);

const root = createRoot(document.getElementById("body"));
root.render(<App />);
